import * as Sentry from "@sentry/react"

export function initSentry(): void {
	const dsn = import.meta.env.VITE_SENTRY_DSN
	if (!dsn) return

	Sentry.init({
		dsn,
		environment: import.meta.env.MODE,
		tracesSampleRate: 0.0,
		replaysOnErrorSampleRate: 1.0,
		replaysSessionSampleRate: 0.0,
		integrations: [Sentry.replayIntegration()],
	})
}

export function setSentryUser(id: string, email?: string): void {
	Sentry.setUser({ id, email })
}

export function clearSentryUser(): void {
	Sentry.setUser(null)
}
